<template>
  <div class="class-wrapper">
    <apexchart ref="chart" :class="classList" type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  name: "QuestionBarChart",
  props: ["attemptsList"],
  data: function() {
    return {
      classList: 'hidden',
      series: [{
        data: [25, 25, 0, 10]
      }],
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 150,
          fontFamily: 'Roboto, sans-serif',
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            barHeight: '40%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
            borderRadius: 7
          }
        },
        colors: ['#6FCF97', '#56ccf2', '#F2C94C', '#EB5757'],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#5F0100']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + " –  " + val + "%" 
          },
          offsetY: -15,
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: ['1st attempt', '2nd attempt', '3rd attempt', '4th attempt'],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false
          },
        },
        yaxis: {
          labels: {
            show: false
          },
        },
        grid: {
          show: false,
          padding: {
            top: -10,
            left: -10
          },  
        },
        tooltip: {
          enabled: false
        },
        legend: {
          show: false
        }
      }
    },
    getPercent(){
      var attemptsSum = this.attemptsList.reduce(function(a,b){
        return a+b;
      }, 0);
      var array1 = [...this.attemptsList];
      array1.forEach((e, i) => {
        array1[i] = e / attemptsSum * 100;        
      });
      return array1;
    },
    seriesData(){
      return this.getPercent;
    },
  },
  watch: {
    attemptsList: function() {
      this.updateChart();
    },
    getPercent: function(val) {
      this.series = [{
        data: [val]
      }];
      this.updateChart();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'));
      this.classList = 'revealed';
    });
    this.updateChart();
  },
  methods: {
    updateChart() {
      this.chartOptions = {
       ...this.chartOptions
      }
      this.series = [{
        data: this.getPercent
      }];
    },
  }
}
</script>

<style>


</style>
